var app = angular.module("leonardo");

var ReportsContactList = function ($scope, $controller, $filter, ReportService) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('Contact Reports');
  $scope.report_type = ReportService.TYPE_CONTACT;

  $scope.fieldsReport = ReportService.fieldsReportContact;

  $scope.getFieldValue = function(report, field) {
    var html = '';
    switch(field) {
      case 'user':
        return (report.account_user && report.account_user.user) ?
          $filter('username')(report.account_user.user) + ' (' + report.account_user.user.email + ')' : '';
      case 'contact_type':
      case 'account':
      case 'portfolio':
      case 'property':
        return report[field] ? report[field].name : '';
      case 'portfolios':
      case 'properties':
      case 'groups':
      case 'managed_by':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function(element){
            html += '<span>' + element.name +'</span>';
          });
          return html;
        }
        else {
          if (report[field]) {
            html = report[field].name;
            return html;
          }
          html = (field === 'managed_by') ? 'Only Owner' : ''
          return html;
        }
      default: return report[field];
    }
  };

};

app.controller('ReportsContactList', ['$scope', '$controller', '$filter', 'ReportService', ReportsContactList]);
